import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { user } from '@app/_shared/_models/user';
import { AuthenticationService } from '@app/_shared/_services/authentication.service';
import { ForumEvenementLieuService } from '@app/_shared/_services/forum/evenement-lieu.service';
import { ForumEvenementService } from '@app/_shared/_services/forum/evenement.service';
import { ForumInscriptionService } from '@app/_shared/_services/forum/inscription.service';
import * as _ from "underscore"
@Component({
  selector: 'app-cllajinscriptionlieux',
  templateUrl: './cllajinscriptionlieux.component.html',
  styleUrls: ['./cllajinscriptionlieux.component.scss']
})
export class CllajinscriptionlieuxComponent implements OnInit,OnDestroy {

  @Output() onNextStep:EventEmitter<any> = new EventEmitter<any>();
  @Output() onPrevStep:EventEmitter<any> = new EventEmitter<any>();

  canNextStep:boolean =false;
  subscriptions: any = [];
  currentUser: user;

lieux;

  constructor(
    public authenticationService: AuthenticationService,
    public inscriptionService:ForumInscriptionService,
    private evenementService:ForumEvenementService,
    private evenementLieuService:ForumEvenementLieuService) {
      this.subscriptions.push(
        this.authenticationService.currentUser.subscribe(
          (x) => {
            this.currentUser = x; }
        )
      );
    }

      ngOnDestroy() {
        _.each(this.subscriptions, (sub) => sub.unsubscribe());
      }

  ngOnInit(): void {
    console.log('on init')
    if(typeof this.inscriptionService.form.lieux == "undefined")
    this.inscriptionService.form.lieux = {}
    if(typeof this.inscriptionService.form.lieux.selectedItems == "undefined")
    this.inscriptionService.form.lieux.selectedItems = []
    this.refreshLieux()
    this.checkCanNextStep()
  }
  refreshLieux(){
    console.log('refreshLieux')
    this.evenementLieuService.getItems({where:{idEvenement:this.evenementService?.selectedItem?.id}},[['id','asc']]).subscribe(res=>{
      this.lieux = res.items;
    },err=>{

    })
  }

  isSelectedItem(item){
    for (let index = 0; index < this.inscriptionService.form.lieux.selectedItems.length; index++) {
      const element = this.inscriptionService.form.lieux.selectedItems[index];
      if(element && element?.id == item.id)
        return true;
    }
    return false;
  }
  selectItem(item){
    this.inscriptionService.form.lieux.selectedItems.push(_.clone(item));
    this.checkCanNextStep()
  }
  unselectItem(item){
    for (let index = 0; index < this.inscriptionService.form.lieux.selectedItems.length; index++) {
      const element = this.inscriptionService.form.lieux.selectedItems[index];
      if(element && element?.id == item.id){
        this.inscriptionService.form.lieux.selectedItems.splice(index, 1);
        break;
      }
    }
    this.checkCanNextStep()
  }

  checkCanNextStep(){
    if(this.inscriptionService.form.lieux.selectedItems.length > 0)
    this.canNextStep = true;
    else this.canNextStep = false
    this.inscriptionService.saveFormSessionStorage()
  }

  nextStep(){
    if(this.canNextStep){
      this.onNextStep.emit()
    }
    else this.checkCanNextStep()
  }
  prevStep(){
      this.onPrevStep.emit()
  }

}
